import router from './router'
import store from './store'
import utils from './utils/utils'
import secret from './utils/secret'
import { getToken, getUserToken } from '@/utils/cookies'
import { removeLocalOrderProsData } from '@/utils/storage'
import { GetUserInfo } from './store/modules/user'
// 不需要删除缓存的路由
const unWantedRemoveLocalData = {
  account: '/account'
}

// console.log(555555999)
// const prodEnv = process.env.NODE_ENV
const CTJZ_PLATFORM_PATH = process.env.CTJZ_PLATFORM_PATH
const SSO_WEB_URL = process.env.SSO_WEB_URL
const READ_PLATFORM_PATH = process.env.READ_PLATFORM_PATH
// console.log("CTJZ_PLATFORM_PATH",CTJZ_PLATFORM_PATH)



router.beforeEach((to, from, next) => {
  // console.log('totototototototototototototototototototototototo',to)
  if(to.meta.title){
    document.title = to.meta.title
  }else{
    document.title = '中国传统建筑文化'
  }
  if (to.matched.length === 0) {
    next()
  } else {
    console.log("to",to)
    const toPath = to.path // 跳转路由
    const toMeta = to.meta // 跳转路由信息
    let requireAuth = toMeta.requireAuth // 是否需要登录
    let jumpAuth = toMeta.jumpAuth // 是否个人中心跳转
    const isLogin = store.getters.isLogin
    // console.log("buildDes_isLogin",isLogin)
    const token = getUserToken() // 游客token
    console.log("build_token", token)
    const userToken = getUserToken() // 登录用户token
    // console.log("getUserToken",userToken)
    let existToken = utils.isNotEmpty(token) // 存在游客token
    
    // 导航栏选中
    navToolbarChecked(toPath)
    // ------------------ 处理重定向路径-start
    let targetUrl = SSO_WEB_URL + toPath
    let existUserToken  ;
    // console.log("targetUrl999",targetUrl);
    // console.log("toPath",toPath);
    //==========================出路支付成功携带状态过去
    let paramsStr =''
    if(to.query.typePay === 'buildPay'){
      let newParamsObj = {
        payWay: secret.decryptText(to.query.payWay),
        outTradeNo: secret.decryptText(to.query.outTradeNo),
        tradeNo: secret.decryptText(to.query.tradeNo),
        tradeStatus: secret.decryptText(to.query.tradeStatus),
        totalAmount: secret.decryptText(to.query.totalAmount)
      }
      Object.entries(newParamsObj).forEach(value => {
        paramsStr+=`&${value[0]}=${secret.encryptionText(value[1])}`
      })
    }
    



    let paramsRedirectUrl = 'redirectUrl=' + secret.encryptionText(CTJZ_PLATFORM_PATH + from.fullPath)+paramsStr
    console.log('paramsRedirectUrl',paramsRedirectUrl)
    let params = '?' + paramsRedirectUrl // 回调路径参数
    // console.log("buildDes_targetUrl",targetUrl, isLogin && jumpAuth)
    let targetFullUrl = (isLogin && jumpAuth) ? targetUrl : targetUrl + params
    console.log("获取重定向地址", targetFullUrl)
    // ------------------ 处理重定向路径-end
    // ------------------ 处理登录数据信息 - start
    // console.log("jumpAuth=",jumpAuth)
    
    if (existToken) { // 存在游客token
      console.log("targetFullUrl",targetFullUrl);
      console.log("GetUserInfo111", targetFullUrl)
      store.dispatch('GetUserInfo').then(res => {
        console.log("GetUserInfo222", res)
      let existUserToken =  res.data; // 存在登录用户token

        console.log("需要登录");
        if (existUserToken) { // 存在登录token
          console.log("存在登录token");
          if (jumpAuth) {
            console.log("jumpAuth错误");
            window.location.href = targetFullUrl
          } else {
            console.log("jumpAuth正确");
            console.log("GetUserInfo333")
            store.dispatch('GetUserInfo').then(res => {
              next()
            }).catch(() => {
            })
          }
        } else { // 不存在登录token
          console.log("不存在登录token");
          window.location.href = targetFullUrl
        }
      })
      




      if (requireAuth) {
        
        window.location.href = targetFullUrl
       
      } else {
        console.log("不需要登录1");
        if (existUserToken) {
          console.log("用户已登录2");
           // 存在登录token
        
          if (jumpAuth) {
            window.location.href = targetFullUrl
            console.log("存在登录token");
          } else {
            console.log("GetUserInfo4444")
            store.dispatch('GetUserInfo').then(res => {
            
              next()
            }).catch(() => {
            })
          }
        } else { // 不存在登录token
          next()
        }
      }
    } else { // 获取游客token
      console.log("获取游客token");
      store.dispatch('findToken').then(res => {
        next()
      })
    }
    // ------------------ 处理登录数据信息 - end
  }
})



// try{ 
//   window["_BFD"] = window["_BFD"] || {}; 
//   _BFD.USER_INFO = {  
//     "cid" : "Ccabp",          //客户标识，实施人员提供 
//     "appkey" : "10662f100f95a35c0fd7cd48404059f6",         //应用标识，实施人员提供 
//     "pv_type" : "0",             //页面埋点方式，0 为自动发送，1 为手动调用 
//     "pos" : true,                //是否启用鼠标点击事件，值为 true/false 
//     "link" : true,               //是否启用链接点击事件，值为 true/false 
//     "title" : "",                //当前页面标题，若此处不回传默认获取 document.title 
//     "openID" : "",               //站点在微信加载时，需回传 openID，否则不用做处理 
//     "phone_number" : " ",         //手机号码，未登录时回传空字符串 
//     "uid" : " "           //用户 id，未登录时回传空字符串
//   }; 
//   // console.log('this.recommendList5',_BFD.USER_INFO)
//   _BFD.script = document.createElement("script"); 
//   _BFD.script.async = true; 
//   _BFD.script.charset = "utf-8"; 
//   _BFD.script.src=('https://data.cabplink.com/js/web.js'); // js 代码路径，由实施人员提供 
//   document.getElementsByTagName("head")[0].appendChild(_BFD.script);
//   }catch(e){} 



router.beforeResolve((to, from, next) => {
  next()
})

/** 路由离开 */
router.afterEach((to, from) => {
  if (to.path !== unWantedRemoveLocalData.account) {
    removeLocalOrderProsData()
  }
})


/** 导航栏选中 */
function navToolbarChecked (path) {
   if (path === '/index') {
    store.commit('SET_ISACTIVE', 0)
  } else if (path === '/xszt') {
    store.commit('SET_ISACTIVE', 1)
  } else if (path === '/zxsc') {
    store.commit('SET_ISACTIVE', 2)
  } else if (path === '/zxkc') {
    store.commit('SET_ISACTIVE', 3)
  } else if (path === '/hyfw') {
    store.commit('SET_ISACTIVE', 4)
  }  else if (path === '/personalHome') {
    store.commit('SET_ISACTIVE', 5)
  }  else if (path === '/vip') {
    store.commit('SET_ISACTIVE', 7)
  } 
}


// WEBPACK FOOTER //
// ./src/permission.js